import * as React from 'react';
import { InputItem } from 'antd-mobile';
// import fixInputDislocation from '@src/utils/fix-input-dislocation';
import Toast from '@src/components/toast';

export default class Input extends React.PureComponent {
  constructor(props) {
    super(props);
    this.onErrorClick = this.onErrorClick.bind(this);
  }

  // componentDidMount() {
  //   fixInputDislocation.bindNode(this.inputRef.inputRef.inputRef);
  // }

  onErrorClick() {
    const { errorMessage } = this.props;
    errorMessage && Toast.info(errorMessage);
  }

  render() {
    // const { onFocus, onBlur } = fixInputDislocation.getEventMethods();

    const { errorMessage, className, ...restProps } = this.props;
    return (
      <InputItem
        {...restProps}
        className={className}
        error={errorMessage}
        onErrorClick={this.onErrorClick}
        // onFocus={onFocus}
        // onBlur={onBlur}
        ref={ref => {
          this.inputRef = ref;
        }}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/mobile-input/index.js